import type MailboxInfo from './MailboxInfo';

/**
 * Provides a string that can be used for in-memory indexer of a MailboxInfo in a map
 * or other structure where an indexer value is needed.
 * @param mailboxInfo MailboxInfo for which the indexer is to be returned
 * @returns Indexer for the MailboxInfo
 */
export default function getIndexerValueForMailboxInfo(mailboxInfo: MailboxInfo): string {
    // Long term we want to use sourceId as the indexer value for the MailboxInfo, as it
    // will be unique for accounts that do not have a userIdentity (such as PST) or
    // when shared / delegate mailboxes can be added as an account. Until that is a required
    // property in MailboxInfo we are going to use the userIdentity as the indexer value.

    // Note: this function and the getMailboxInfoForIndexerValue must be kept in sync
    return mailboxInfo.userIdentity ?? '';
}
